import React from 'react';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import ConceptSidebar from './ConceptSidebar';
import SessionTimer from './SessionTimer';
import ProgressBar from './ProgressBar';
import FirstMessageModal from './FirstMessageModal';
import PerformanceSummaryModal from './PerformanceSummaryModal';

const ChatBox = ({
  chatMessages,
  firstAssistantMessage,
  hasEnoughMessages,
  showFirstMessageModal,
  setShowFirstMessageModal,
  userMessage,
  setUserMessage,
  onSendMessage,
  isSending,
  elapsedTime,
  startTime,
  getProgressPercent,
  messagesEndRef,
  selectedConcept,
  setSelectedConcept,
  moduleId,
  concepts,
  conceptDetailsRef,
  isGeneratingPerformanceSummary,
  showCompleteOverlay,
  performanceSummary,
  lastAssistantMessage,
  onPerformanceSummaryExit,
  fadeOut
}) => {
  return (
    <div className={`chat-box ${fadeOut ? 'fade-out' : ''}`}>
      {startTime && <SessionTimer elapsedTime={elapsedTime} />}

      <div className="messages-container">
        <MessageList
          chatMessages={chatMessages}
          isGeneratingPerformanceSummary={isGeneratingPerformanceSummary}
          firstAssistantMessage={firstAssistantMessage}
          hasEnoughMessages={hasEnoughMessages}
          showFirstMessageModal={showFirstMessageModal}
          onShowFirstMessage={() => setShowFirstMessageModal(true)}
          messagesEndRef={messagesEndRef}
        />
      </div>

      <ProgressBar getProgressPercent={getProgressPercent} />

      <MessageInput
        userMessage={userMessage}
        setUserMessage={setUserMessage}
        onSendMessage={onSendMessage}
        isSending={isSending}
      />

      <ConceptSidebar
        concepts={concepts}
        moduleId={moduleId}
        selectedConcept={selectedConcept}
        setSelectedConcept={setSelectedConcept}
        conceptDetailsRef={conceptDetailsRef}
      />

      {showFirstMessageModal && (
        <FirstMessageModal
          firstMessage={chatMessages[0]?.message}
          onClose={() => setShowFirstMessageModal(false)}
        />
      )}

      {showCompleteOverlay && (
        <PerformanceSummaryModal
          performanceSummary={performanceSummary}
          lastAssistantMessage={lastAssistantMessage}
          onClose={onPerformanceSummaryExit}
        />
      )}
    </div>
  );
};

export default ChatBox;
